export const TEXT_MASKS = {
  phone: [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  zip:   [/\d/, /\d/, /\d/, /\d/, /\d/],
  card:  [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  cvc:   [/\d/, /\d/, /\d/, /\d/],
  expiry: [/\d/, /\d/, '/', /\d/, /\d/]
}



// WEBPACK FOOTER //
// ./src/constants/text_masks.ts